module.exports = __webpack_public_path__ + "img/hg-2.2158a42f.jpg";